import sacUnitChange from '../modules/sacUnitChange';
import carouselMobile from '../modules/carouselMobile';
import sacSutComplaint from '../modules/sacSutComplaint';

sacUnitChange();
carouselMobile(768, '.ethicalChannel__carousel');
carouselMobile(992, '.contactDirect__carousel');
sacSutComplaint();